module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmI1N2QwMWEzNzI1NjViMzg0YTUyM2ZlM2RjNDI2MTQucG5nIjs="